export default __webpack_public_path__ + "static/media/hht1_ani_12.8b6ee4ab.png";